export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20sleek%20smartphone%20displaying%20a%20modern%20movie%20streaming%20app%20interface%20with%20film%20posters%20in%20a%20grid%20layout%2C%20warm%20red%20and%20dark%20theme%2C%20clean%20UI%20design%2C%20minimal%20product%20photography%20on%20white%20background%2C%20soft%20natural%20lighting&width=500&height=500&seq=app-mobile-wuma&orientation=squarish"
                alt="午马影院手机App观影界面"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                手机观影
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-5">
                午马影院移动端完美适配，随时随地畅享高清电影在线观看。智能压缩技术节省流量，地铁、午休、旅途中轻松追剧。支持横竖屏切换与倍速播放，让手机观影也能拥有影院级体验。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium">
                  <i className="ri-android-fill"></i> Android
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium">
                  <i className="ri-apple-fill"></i> iOS
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium">
                  <i className="ri-smartphone-line"></i> H5 网页版
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}